import { Toast, ToastComponent } from '@opallabs/lapidary'

type MigrationToastProps = {
  storyName: string
  planTitle?: string
  boardTitle?: string
}

export const MigrationToast: ToastComponent<MigrationToastProps> = ({
  storyName,
  planTitle,
  boardTitle,
  ...toastProps
}) => {
  const destinations = [planTitle, boardTitle].filter(
    (title): title is string => Boolean(title)
  )
  const destinationText = new Intl.ListFormat().format(destinations)

  return (
    <Toast
      {...toastProps}
      title="Migration Started"
      message={
        <span>
          Migrating moments from &ldquo;{storyName}&rdquo; to {destinationText}.
          This may take several minutes to complete.
        </span>
      }
    />
  )
}
